import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pplus-admin-effective-permissions',
  templateUrl: './effective-permissions.component.html',
  styleUrls: ['./effective-permissions.component.scss']
})
export class EffectivePermissionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
